module.exports = __webpack_public_path__ + "img/2023-4.43af0091.jpg";